import React from 'react'
import { ReactNode } from 'react'
import HomeActionCard from './HomeActionCard'

interface CardTeacherLinkProps {
  title: string
  subtitle: string
  icon: ReactNode
  path?: string
}

/** Card de ação do professor — delega para o card único da Home. */
export default function CardTeacherLink({ title, subtitle, icon, path }: CardTeacherLinkProps) {
  return <HomeActionCard icon={icon} title={title} description={subtitle} path={path} />
}
